import { Line, LineChart, ResponsiveContainer } from "recharts";

interface PriceSparklineProps {
  data: number[];
  color: string;
  height?: number;
}

export default function PriceSparkline({ data, color, height = 56 }: PriceSparklineProps) {
  const chartData = data.map((value, index) => ({ index, value }));

  return (
    <div className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 6, right: 4, bottom: 6, left: 4 }}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}